import { Loader2 } from 'lucide-react';

/** What a screen shows while it waits to open. */
export function PageLoading() {
  return (
    <div className="flex items-center justify-center gap-2 py-16 text-sm text-slate-500">
      <Loader2 className="h-4 w-4 animate-spin" /> Loading…
    </div>
  );
}
